import { HomeQuery, HOME_QUERY } from '@layouts/home'
import { fetchSSRData } from '@lib/ssr-fetch'

function Home(props) {
  return <HomeQuery {...props} />
}

Home.getInitialProps = async ({ query, req }) => {
  const reqHeaders = req ? req.headers : {}
  const result = await fetchSSRData({
    query,
    graphqlQuery: HOME_QUERY,
    variables: query,
    transform: (data) => data?.homepageCollection?.items?.[0],
  })
  return { ...result, reqHeaders, ssrData: result.data }
}

export default Home
